import { Form, Modal, Input, Select, Button, Checkbox, Space } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { getDirectusClient } from "../../../lib/directus";

import { readItems, updateItem } from "@directus/sdk";
const { Option } = Select;

function Editproduct({ openedit, editModal, getProducts, productselect }) {
  //const [openadd, setOpenadd] = useState(false);
  const [form] = Form.useForm();
  const [grupos, setGrupos] = useState([]);
  const [estadoproducto, setEstadoproducto] = useState([]);
  const [precioFinal, setPrecioFinal] = useState(0);

  const onFinish = async (values) => {
    const directus = await getDirectusClient();
    directus
      .request(
      updateItem("productos",parseInt(productselect.id), {
        referencia: values.referencia,
        nombre: values.nombre,
        grupo: values.grupo,
        precio_base: values.precio_base,
        preciosinimp: values.preciosinimp,
        descuento_comercial: values.descuento_comercial,
        estado: values.estado,
        min: values.min,
        precios: values.precios,
      }))
      .then((res) => {
        getProducts();
        editModal();
        form.resetFields();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    console.log(productselect);
    form.setFieldValue("referencia", productselect.referencia);
    form.setFieldValue("nombre", productselect.nombre);
    form.setFieldValue("grupo", productselect.grupo?.id);
    form.setFieldValue("precio_base", productselect.precio_base);
    form.setFieldValue("descuento_comercial", productselect.descuento_comercial);
    
    // Calcular el precio final inicial
    const precio = parseFloat(productselect.precio_base) || 0;
    const descuentoPorcentaje = parseFloat(productselect.descuento_comercial) || 0;
    const descuentoDecimal = descuentoPorcentaje / 100;
    const precioFinal = precio - (precio * descuentoDecimal);
    
    form.setFieldValue("preciosinimp", precioFinal.toFixed(2));
    form.setFieldValue("estado", parseInt(productselect.estado?.id));
    form.setFieldValue("min", productselect.min);
    form.setFieldValue("precios", productselect.precios);
  }, [productselect]);

  const onReset = () => {
    form.resetFields();
  };
  const getGrupos = async () => {
    const directus = await getDirectusClient();
    directus
      .request(readItems("grupos"))
      .then((res) => {
        console.log(res);
        setGrupos(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getEstadoproducto = async () => {
    const directus = await getDirectusClient();
    directus
      .request(
      readItems("estadoproducto"))
      .then((res) => {
        console.log(res);
        setEstadoproducto(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getGrupos();
    getEstadoproducto();
  }, []);

  return (
    <Modal
      title="Editar Producto"
      open={openedit}
      onCancel={editModal}
      footer={false}
    >
      <Form
        form={form}
        name="control-hooks"
        onFinish={onFinish}
        style={{
          maxWidth: 600,
        }}
      >
        <Form.Item
          name="referencia"
          label="Referencia"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="nombre"
          label="Nombre de Producto"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="grupo"
          label="Grupo"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select placeholder="Selecione un Grupo" allowClear>
            {grupos.map((grupo) => {
              return <Option value={grupo.id}>{grupo.nombre}</Option>;
            })}
          </Select>
        </Form.Item>

        <Form.Item
          name="precio_base"
          label="Precio base"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input 
            type="number"
            onChange={(e) => {
              const precio = parseFloat(e.target.value) || 0;
              const descuentoPorcentaje = parseFloat(form.getFieldValue('descuento_comercial') || 0);
              const descuentoDecimal = descuentoPorcentaje / 100;
              const precioFinal = precio - (precio * descuentoDecimal);
              form.setFieldsValue({ preciosinimp: precioFinal.toFixed(2) });
            }}
          />
        </Form.Item>

        <Form.Item
          name="descuento_comercial"
          label="Descuento Comercial (%)"
          rules={[
            {
              required: false,
            },
          ]}
        >
          <Input 
            type="number"
            onChange={(e) => {
              const descuentoPorcentaje = parseFloat(e.target.value) || 0;
              const precio = parseFloat(form.getFieldValue('precio_base') || 0);
              const descuentoDecimal = descuentoPorcentaje / 100;
              const precioFinal = precio - (precio * descuentoDecimal);
              form.setFieldsValue({ preciosinimp: precioFinal.toFixed(2) });
            }}
          />
        </Form.Item>

        <Form.Item
          name="preciosinimp"
          label="Precio sin Impuestos"
        >
          <Input 
            readOnly
            style={{ color: '#1890ff', fontWeight: 'bold' }}
          />
        </Form.Item>

        <Form.Item
          name="estado"
          label="Estado de Producto"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select placeholder="Seleccione un Estado " allowClear>
            {estadoproducto.map((estadoproducto) => {
              return (
                <Option value={estadoproducto.id}>
                  {estadoproducto.nombre}
                </Option>
              );
            })}
          </Select>
        </Form.Item>

        <Form.Item
          valuePropName="checked"
          name="min"
          label="Min"
         
        >
          <Checkbox></Checkbox>
        </Form.Item>

        <h3>Añadir Precios </h3>

        <Form.List name="precios">
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }) => (
                <Space
                  key={key}
                  style={{ display: "flex", marginBottom: 8 }}
                  align="baseline"
                >
                  <Form.Item
                    {...restField}
                    name={[name, "precio"]}
                    rules={[{ required: true }]}
                  >
                    <Input placeholder="Precio" />
                  </Form.Item>
                  <Form.Item
                    {...restField}
                    name={[name, "alias"]}
                    rules={[{ required: true }]}
                  >
                    <Input placeholder="Alias" />
                  </Form.Item>
                  <MinusCircleOutlined onClick={() => remove(name)} />
                </Space>
              ))}
              <Form.Item>
                <Button
                  type="dashed"
                  onClick={() => add()}
                  block
                  icon={<PlusOutlined />}
                >
                  Agregar nuevo precio
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>

        <Form.Item>
          <Button type="primary" htmlType="submit">
           Editar
          </Button>
          <Button htmlType="button" onClick={onReset}>
            Reset
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}

Editproduct.propTypes = {
  openedit: PropTypes.bool.isRequired,
  editModal: PropTypes.func.isRequired,
  getProducts: PropTypes.func.isRequired,
  productselect: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    referencia: PropTypes.string,
    nombre: PropTypes.string,
    grupo: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    }),
    preciosinimp: PropTypes.number,
    descuento_comercial: PropTypes.number,
    estado: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    }),
    min: PropTypes.bool,
    precios: PropTypes.array
  }).isRequired
};

export default Editproduct;
